import AttachmentImageGallery from '@/components/AiAskBar/AttachmentImageGallery'

export default function UserChatBubbleGalleryOverlay({ gallery }) {
  return (
    <AttachmentImageGallery
      key={gallery.sentGallerySession}
      open={gallery.sentGalleryOpen && gallery.sentGalleryItems.length > 0}
      onClose={gallery.closeSentImageGallery}
      items={gallery.sentGalleryItems}
      initialIndex={gallery.sentGalleryInitialIndex}
    />
  )
}
